import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { dripKeys } from './queryKeys';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
import markUrl from './markUrl';
const useDrips = (params) => {
    const additional = useQueryRequestParams();
    return useQuery({
        queryFn: () => axios.get(markUrl('drips/list/'), {
            ...additional,
            params
        }),
        queryKey: dripKeys.listFor(params),
        staleTime: 30_000
    });
};
export default useDrips;
